<template>
    <div class="owl-thumb-item" v-bind:class="{ 'active' : service.selected }" v-if="service!=null" v-on:click="change">
        <span class="media-left"><i class="" v-bind:class="service.icon"></i></span>
        <div class="media-body">
            <h5 v-html="service.title"></h5>
            <p v-html="service.subtitle"></p>
        </div>
    </div>
</template>

<script>
    export default {
        props : {
            service : {
                type : Object,
                default : null
            },
            index: {
                type : Number,
                default : 0
            }
        },
        methods : {
            change : function(){
                this.service.selected = true;
                this.$emit('change', this.service);
            }
        },
        created : function(){
            this.service['index'] = this.index;
        }
    }
</script>


// WEBPACK FOOTER //
// Item.vue?a0b0898a